import { FC, ReactNode, useState } from 'react';
import { TooltipContainer } from './TooltipContainer';

export const TOOLTIP_CLASSNAME = '__mapui_tooltip';

export const TOOLTIP_POSITION = {
  top: 'top',
  bottom: 'bottom',
  left: 'left',
  right: 'right',
};

export type PositionType = 'top' | 'bottom' | 'left' | 'right';

export const TOOLTIP_ALIGNMENT = {
  start: 'start',
  center: 'center',
  end: 'end',
};

export type Alignment = 'start' | 'center' | 'end';

export interface TooltipProps {
  children: ReactNode;
  content?: ReactNode | string;
  position?: PositionType;
  alignment?: Alignment;
  offsetDown?: string;
  offsetRight?: string;
  offsetLeft?: string;
  offsetUp?: string;
  width?: 'auto' | string;
}

export const Tooltip: FC<TooltipProps> = ({
  children,
  content,
  position = 'bottom',
  alignment = 'center',
  offsetDown = '0px',
  offsetRight = '0px',
  offsetLeft = '0px',
  offsetUp = '0px',
  width = 'auto',
}: TooltipProps) => {
  const [isMouseOver, setMouseOver] = useState<boolean>(false);

  return (
    <span
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
    >
      {children}
      {isMouseOver && (
        <TooltipContainer
          position={position}
          alignment={alignment}
          offsetDown={offsetDown}
          offsetRight={offsetRight}
          offsetLeft={offsetLeft}
          offsetUp={offsetUp}
          width={width}
        >
          {content}
        </TooltipContainer>
      )}
    </span>
  );
};
